/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all notifications for a workspace.
         * @param {boolean} [isRead]
         * @param {'BankDetail' | 'Invitation' | 'Invoice' | 'Membership' | 'PaymentRule' | 'Payout' | 'Title' | 'User' | 'Workspace'} [subjectType]
         * @param {string} [userId]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerFindAll: (isRead, subjectType, userId, workspaceId, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (isRead !== undefined) {
                localVarQueryParameter['isRead'] = isRead;
            }
            if (subjectType !== undefined) {
                localVarQueryParameter['subjectType'] = subjectType;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the HTML return for invitation preview
         * @param {InvitationTemplateEnum} invitationTemplate
         * @param {string} [inviter]
         * @param {string} [title]
         * @param {string} [workspaceName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerPreviewInvitation: (invitationTemplate, inviter, title, workspaceName, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'invitationTemplate' is not null or undefined
            assertParamExists('notificationControllerPreviewInvitation', 'invitationTemplate', invitationTemplate);
            const localVarPath = `/notification/preview/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (invitationTemplate !== undefined) {
                localVarQueryParameter['invitationTemplate'] = invitationTemplate;
            }
            if (inviter !== undefined) {
                localVarQueryParameter['inviter'] = inviter;
            }
            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }
            if (workspaceName !== undefined) {
                localVarQueryParameter['workspaceName'] = workspaceName;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing notification
         * @param {string} id
         * @param {UpdateNotificationDto} updateNotificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerUpdate: (id, updateNotificationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('notificationControllerUpdate', 'id', id);
            // verify required parameter 'updateNotificationDto' is not null or undefined
            assertParamExists('notificationControllerUpdate', 'updateNotificationDto', updateNotificationDto);
            const localVarPath = `/notification/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all notifications for a workspace.
         * @param {boolean} [isRead]
         * @param {'BankDetail' | 'Invitation' | 'Invoice' | 'Membership' | 'PaymentRule' | 'Payout' | 'Title' | 'User' | 'Workspace'} [subjectType]
         * @param {string} [userId]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerFindAll(isRead, subjectType, userId, workspaceId, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.notificationControllerFindAll(isRead, subjectType, userId, workspaceId, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the HTML return for invitation preview
         * @param {InvitationTemplateEnum} invitationTemplate
         * @param {string} [inviter]
         * @param {string} [title]
         * @param {string} [workspaceName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerPreviewInvitation(invitationTemplate, inviter, title, workspaceName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.notificationControllerPreviewInvitation(invitationTemplate, inviter, title, workspaceName, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing notification
         * @param {string} id
         * @param {UpdateNotificationDto} updateNotificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerUpdate(id, updateNotificationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.notificationControllerUpdate(id, updateNotificationDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NotificationsApiFp(configuration);
    return {
        /**
         *
         * @summary Get all notifications for a workspace.
         * @param {boolean} [isRead]
         * @param {'BankDetail' | 'Invitation' | 'Invoice' | 'Membership' | 'PaymentRule' | 'Payout' | 'Title' | 'User' | 'Workspace'} [subjectType]
         * @param {string} [userId]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerFindAll(isRead, subjectType, userId, workspaceId, page, pageSize, sortBy, options) {
            return localVarFp
                .notificationControllerFindAll(isRead, subjectType, userId, workspaceId, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the HTML return for invitation preview
         * @param {InvitationTemplateEnum} invitationTemplate
         * @param {string} [inviter]
         * @param {string} [title]
         * @param {string} [workspaceName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerPreviewInvitation(invitationTemplate, inviter, title, workspaceName, options) {
            return localVarFp
                .notificationControllerPreviewInvitation(invitationTemplate, inviter, title, workspaceName, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing notification
         * @param {string} id
         * @param {UpdateNotificationDto} updateNotificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerUpdate(id, updateNotificationDto, options) {
            return localVarFp
                .notificationControllerUpdate(id, updateNotificationDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     *
     * @summary Get all notifications for a workspace.
     * @param {boolean} [isRead]
     * @param {'BankDetail' | 'Invitation' | 'Invoice' | 'Membership' | 'PaymentRule' | 'Payout' | 'Title' | 'User' | 'Workspace'} [subjectType]
     * @param {string} [userId]
     * @param {string} [workspaceId]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    notificationControllerFindAll(isRead, subjectType, userId, workspaceId, page, pageSize, sortBy, options) {
        return NotificationsApiFp(this.configuration)
            .notificationControllerFindAll(isRead, subjectType, userId, workspaceId, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the HTML return for invitation preview
     * @param {InvitationTemplateEnum} invitationTemplate
     * @param {string} [inviter]
     * @param {string} [title]
     * @param {string} [workspaceName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    notificationControllerPreviewInvitation(invitationTemplate, inviter, title, workspaceName, options) {
        return NotificationsApiFp(this.configuration)
            .notificationControllerPreviewInvitation(invitationTemplate, inviter, title, workspaceName, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing notification
     * @param {string} id
     * @param {UpdateNotificationDto} updateNotificationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    notificationControllerUpdate(id, updateNotificationDto, options) {
        return NotificationsApiFp(this.configuration)
            .notificationControllerUpdate(id, updateNotificationDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
